import {curUserIsAdmin, isTeam} from '@/domains/space/Repository/knowledgeUtils';

export const calCanShowPublish = (
    repository: Repository | null,
    userGuid: string,
    canEdit: boolean) => {
    if (isTeam(repository)) {
        return canEdit;
    }
    return repository && curUserIsAdmin(repository);
};
